import React, { CSSProperties, ReactNode } from 'react';
import { Link, To } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import classNames from 'classnames';

type Props = {
    readonly label: ReactNode;
    readonly linkTo: To;
    readonly photoUrl?: string;
    readonly photoClassName?: string;
    readonly textToHighlight: string;
    readonly highlightSearchWords: ReadonlyArray<string>;
    readonly onClick: (textToHighlight: string | undefined) => void;
    readonly containerStyle?: CSSProperties;
};

export const TopHit = (props: Props) => {
    return (
        <Link
            className="top-hit-entry"
            onClick={() => {
                props.onClick(props.textToHighlight);
            }}
            to={props.linkTo}
        >
            <div
                className={classNames('top-hit-result', 'suggestion-arrow-nav', { withPhoto: !!props.photoUrl })}
                style={props.containerStyle}
            >
                <div className="info">
                    {props.photoUrl ? (
                        <div>
                            <div
                                className={classNames('photo', props.photoClassName)}
                                style={{ backgroundImage: `url(${props.photoUrl})` }}
                            />
                        </div>
                    ) : null}
                    <div className="label">{props.label}</div>
                    <div className="th-a">
                        <Highlighter
                            autoEscape={true}
                            highlightClassName="suggestion-highlight"
                            searchWords={props.highlightSearchWords as string[]}
                            textToHighlight={props.textToHighlight}
                        />
                    </div>
                </div>
            </div>
        </Link>
    );
};

TopHit.defaultProps = {
    onClick: () => {},
    linkTo: {},
    photoClassName: '',
    label: '',
    highlightSearchWords: [],
    textToHighlight: '',
    containerStyle: { clear: 'both' }
};
